import { BaseApi } from "./BaseApi";
import { ConfigurationApi } from "./ConfigurationApi";
import { MailApi } from "./MailApi";
import { PriceApi } from "./PriceApi";
import { CheckoutApi } from "./CheckoutApi";

const configurationApi = new ConfigurationApi(new BaseApi());
const mailApi = new MailApi(new BaseApi());
const priceApi = new PriceApi(new BaseApi());
const checkoutApi = new CheckoutApi(new BaseApi());

class Api
{
    get configurationApi() { return configurationApi; }
    get mailApi() { return mailApi; }
    get priceApi() { return priceApi; }
    get checkoutApi() { return checkoutApi; }
}

export const api = new Api();

export const createApi = (fetch: any) => ({
    configurationApi: new ConfigurationApi(new BaseApi(fetch)),
    mailApi: new MailApi(new BaseApi(fetch)),
    priceApi: new PriceApi(new BaseApi(fetch)),
    checkoutApi: new CheckoutApi(new BaseApi(fetch)),
});